import { CarouselIndex } from './carousel-index.model';
import { SelectedOption } from './selected-option.model';

export class SurveyMetadata {
  selectedValues: SelectedOption[];
  selectedCarouselValues: CarouselIndex[];

  constructor(
    public questionId: string,
    public terminateInd: boolean = false
  ) {}
}
